import { render, staticRenderFns } from "./reglist.vue?vue&type=template&id=3769103b&scoped=true"
import script from "./reglist.vue?vue&type=script&lang=js"
export * from "./reglist.vue?vue&type=script&lang=js"
import style0 from "./reglist.vue?vue&type=style&index=0&id=3769103b&prod&lang=css"
import style1 from "./reglist.vue?vue&type=style&index=1&id=3769103b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3769103b",
  null
  
)

export default component.exports